import React from 'react';
import { Box } from '@mui/material';
import Text from './Text';
import { colors, fillImageSx } from '../theme/designTokens';

const TeamMemberCard = ({ role, name, bio, image, imageLeft = true }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          md: imageLeft ? '280px 1fr' : '1fr 280px',
        },
        gap: { xs: 3, md: 5 },
        alignItems: 'start',
        maxWidth: 1000,
        mx: 'auto',
        mb: { xs: 5, md: 7 },
        py: { xs: 3, md: 4 },
        borderTop: `1px solid ${colors.borderLight}`,
      }}
    >
      <Box
        sx={{
          order: { xs: 0, md: imageLeft ? 0 : 1 },
          width: { xs: '70%', sm: 240, md: '100%' },
          maxWidth: 280,
          mx: { xs: 'auto', md: 0 },
          aspectRatio: '4 / 5',
          overflow: 'hidden',
          border: `1px solid ${colors.borderLight}`,
          background: colors.navyDark,
        }}
      >
        <Box
          component="img"
          src={image}
          alt={name}
          decoding="async"
          loading="lazy"
          sx={{
            ...fillImageSx,
            objectPosition: 'center top',
          }}
        />
      </Box>

      <Box
        sx={{
          order: { xs: 1, md: imageLeft ? 1 : 0 },
          textAlign: { xs: 'center', md: 'left' },
          pt: { md: 1 },
        }}
      >
        <Text
          variant="eyebrow"
          sx={{ color: colors.slate, mb: 1.5, display: 'block' }}
        >
          {role}
        </Text>
        <Text variant="h2" component="h2" color="primary" sx={{ mb: 2, display: 'block' }}>
          {name}
        </Text>
        <Box
          sx={{
            width: 40,
            height: 1,
            background: colors.navy,
            mb: 2.5,
            mx: { xs: 'auto', md: 0 },
          }}
        />
        <Text variant="body" color="secondary" sx={{ whiteSpace: 'pre-line', display: 'block' }}>
          {bio}
        </Text>
      </Box>
    </Box>
  );
};

export default TeamMemberCard;
